import { NotifierService } from "./notifierService/notifier.service";
import { Injectable } from "@angular/core";
import { AppServices } from "app/app.services";
import { UtilityScripts } from "../helpers/utility-scripts";
import { AppConstants } from "app/core/vo/app-constants";

@Injectable()
export class ThemingService extends NotifierService {
	public static readonly DEFAULT_PRIMARY_COLOR: string = "007EB3"; //BLUE
	public static readonly DEFAULT_SECONDARY_COLOR: string = "FFCC00"; //YELLOW

	public static readonly DEFAULT_FONT_COLOR_1A: string = "FFFFFF";
	public static readonly DEFAULT_FONT_COLOR_1B: string = "5F5B5B";
	public static readonly DEFAULT_FONT_COLOR_1C: string = "726D6D";

	private arrThemeColors: any[];
	constructor() {
		super();
	}
	public initialize(theme_colors: any[]) {
		let primary_colors: any[] = this.populatePrimaryColors(
			ThemingService.DEFAULT_PRIMARY_COLOR
		);
		let secondary_colors: any[] = this.populateSecondaryColors(
			ThemingService.DEFAULT_SECONDARY_COLOR
		);
		let font_colors: any[] = this.populateFontColors();
		if (theme_colors && theme_colors.length > 0) {
			const primaryColor: any = theme_colors.find(
				(item) => item.type == "primary_color"
			);
			const scondaryColor: any = theme_colors.find(
				(item) => item.type == "secondary_color"
			);
			const fontColors: any = theme_colors.find(
				(item) => item.type == "font-colors"
			);
			if (primaryColor) {
				if (primaryColor.core_color) {
					primary_colors = this.populatePrimaryColors(
						primaryColor.core_color.replace("#", "")
					);
				}
				primary_colors[1].value = primaryColor.core_color_b
					? primaryColor.core_color_b
					: primary_colors[1].value;
				primary_colors[2].value = primaryColor.core_color_c
					? primaryColor.core_color_c
					: primary_colors[2].value;
			}
			if (scondaryColor) {
				if (scondaryColor.core_color) {
					secondary_colors = this.populateSecondaryColors(
						scondaryColor.core_color.replace("#", "")
					);
				}
				secondary_colors[1].value = scondaryColor.core_color_b
					? scondaryColor.core_color_b
					: secondary_colors[1].value;
				secondary_colors[2].value = scondaryColor.core_color_c
					? scondaryColor.core_color_c
					: secondary_colors[2].value;
			}
			if (fontColors) {
				font_colors[0].value = fontColors.core_color_a
					? fontColors.core_color_a
					: font_colors[0].value;
				font_colors[1].value = fontColors.core_color_b
					? fontColors.core_color_b
					: font_colors[1].value;
				font_colors[2].value = fontColors.core_color_c
					? fontColors.core_color_c
					: font_colors[2].value;
			}
		}
		this.arrThemeColors = primary_colors
			.concat(secondary_colors)
			.concat(font_colors);
		console.log("arrThemeColors. ", this.arrThemeColors);
	}
	public setTheme() {
		if (this.arrThemeColors) {
			for (let item of this.arrThemeColors) {
				document.documentElement.style.setProperty(`${item.key}`, item.value);
			}
		}
	}
	private populateFontColors() {
		const core_color_A: any = {
			key: "--core-font-color-1A",
			value: `#${ThemingService.DEFAULT_FONT_COLOR_1A}`,
		};
		const core_color_B: any = {
			key: "--core-font-color-1B",
			value: `#${ThemingService.DEFAULT_FONT_COLOR_1B}`,
		};
		const core_color_C: any = {
			key: "--core-font-color-1C",
			value: `#${ThemingService.DEFAULT_FONT_COLOR_1C}`,
		};
		return [core_color_A, core_color_B, core_color_C];
	}
	private populatePrimaryColors(base_color: string) {
		const core_color_A: any = {
			key: "--core-color-1A",
			value: `#${base_color}`,
		};
		const core_color_B: any = {
			key: "--core-color-1B",
			value: this.getColor(base_color, -2),
		};
		const core_color_C: any = {
			key: "--core-color-1C",
			value: this.getColor(base_color, -4),
		};
		return [core_color_A, core_color_B, core_color_C];
	}
	private populateSecondaryColors(base_color: string) {
		const core_color_A: any = {
			key: "--core-color-2A",
			value: `#${base_color}`,
		};
		const core_color_B: any = {
			key: "--core-color-2B",
			value: this.getColor(base_color, 4),
		};
		const core_color_C: any = {
			key: "--core-color-2C",
			value: this.getColor(base_color, -1),
		};
		return [core_color_A, core_color_B, core_color_C];
	}

	private getColor(colorValue, percentage) {
		var color = this.hexToRGB(colorValue);
		console.log("color ", color);
		if (percentage > 0) {
			//console.log('rgbTint. ',this.rgbTint(color, parseInt(percentage)));
			return `#${this.rgbToHex(this.rgbTint(color, parseInt(percentage)))}`;
		} else {
			//console.log('rgbShade. ',Math.abs(percentage ));
			return `#${this.rgbToHex(this.rgbShade(color, Math.abs(percentage)))}`;
		}
	}

	private hexToRGB(colorValue) {
		return {
			red: parseInt(colorValue.substr(0, 2), 16),
			green: parseInt(colorValue.substr(2, 2), 16),
			blue: parseInt(colorValue.substr(4, 2), 16),
		};
	}

	private rgbToHex(rgb) {
		return (
			this.intToHex(rgb.red) +
			this.intToHex(rgb.green) +
			this.intToHex(rgb.blue)
		);
	}

	private intToHex(rgbint) {
		return this.pad(
			Math.min(Math.max(Math.round(rgbint), 0), 255).toString(16),
			2
		);
	}

	private rgbTint(rgb, i) {
		return {
			red: rgb.red + (255 - rgb.red) * i * 0.1,
			green: rgb.green + (255 - rgb.green) * i * 0.1,
			blue: rgb.blue + (255 - rgb.blue) * i * 0.1,
		};
	}

	private rgbShade(rgb, i) {
		return {
			red: rgb.red * (1 - 0.1 * i),
			green: rgb.green * (1 - 0.1 * i),
			blue: rgb.blue * (1 - 0.1 * i),
		};
	}

	private pad(number, length) {
		var str = "" + number;
		while (str.length < length) {
			str = "0" + str;
		}
		return str;
	}
}
